"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.auditLoggerStore = void 0;
const api_1 = require("client/api");
const api_2 = require("client/api");
const mobx_1 = require("mobx");
class AuditLoggerStore {
    constructor() {
        this.auditLog = async (logData) => {
            const response = await api_1.AuditLoggerEndpoint.auditlog.apiCall(null, { logData });
            if (api_2.isError(response)) {
                console.error('Error in auditLog', response.code);
            }
        };
    }
}
__decorate([
    mobx_1.action
], AuditLoggerStore.prototype, "auditLog", void 0);
exports.auditLoggerStore = new AuditLoggerStore();



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/store/audit-logger-store.ts
// module id = 3277
// module chunks = 0